import * as React from "react"

export default function ArrowLeftIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 13v7l-8-8 8-8v7h8v2h-8z" fill={props.fill} />
    </svg>
  )
}